import { Card, Col, Row, Spinner } from "react-bootstrap";
import useUserInfo from "../../../hooks/use-user-info";
import { useUser } from "../../../context/UserContext";
import { formatDate } from "../../../utils";
import { useInfluencerBonus } from "../../BonusInfluencer/hooks/use-Influencer-bonus";

// Define the interface for a single store statistic
interface StoreStat {
  id: number;
  title: string;
  value: string | React.ReactNode;
  change: string | React.ReactNode;
  changeColor: string;
  icon: string;
  iconBgColor: string;
}

interface WelcomeProps {
  isBlocked?: boolean;
}

const Welcome = ({ isBlocked = false }: WelcomeProps) => {
  const { name, country } = useUserInfo();
  const { userData, isLoading } = useUser();
  const {
    totalEarned,
    startDate,
    endDate,
    isCurrentWeek,
    isLoading: bonusLoading
  } = useInfluencerBonus();

  // Datos dinámicos basados en el estado del usuario
  const storeStats: StoreStat[] = [
    {
      id: 1,
      title: "Bono Influencer",
      value: isLoading && !userData ? (
        <Spinner animation="border" size="sm" />
      ) : userData?.network?.influencer_bonus_status ? "Activo" : "Inactivo",
      change: isLoading && !userData ? (
        "-"
      ) : `Hasta: ${userData?.network?.influencer_bonus_finish_date ? formatDate(userData?.network?.influencer_bonus_finish_date) : "-"}`,
      changeColor: isLoading && !userData ? "white" : userData?.network?.influencer_bonus_status ? "success" : "danger",
      icon: "ri-vip-crown-fill",
      iconBgColor: "primary",
    },
    {
      id: 2,
      title: "Regalías",
      value: isLoading && !userData ? (
        <Spinner animation="border" size="sm" />
      ) : userData?.network?.loyalty_status ? "Activo" : "Inactivo",
      change: isLoading && !userData ? (
        "-"
      ) : `Corte: ${userData?.network?.loyalty_finish_date ? formatDate(userData?.network?.loyalty_finish_date) : "-"}`,
      changeColor: isLoading && !userData ? "white" : userData?.network?.loyalty_status ? "success" : "danger",
      icon: "ri-money-dollar-circle-line",
      iconBgColor: "success",
    },
    {
      id: 3,
      title: "Puntos Influencer",
      value: bonusLoading ? (
        <Spinner animation="border" size="sm" />
      ) : (
        userData?.network?.influencer_bonus_status ? (
          <div>
            <div className="fw-bold">{totalEarned.toString()}</div>
          </div>
        ) : "-"),
      change: bonusLoading ? "-" : userData?.network?.influencer_bonus_status ? `${startDate} - ${endDate}` : "-",
      changeColor: bonusLoading ? "white" : userData?.network?.influencer_bonus_status ? isCurrentWeek ? "success" : "danger" : "white",
      icon: "ri-coin-line",
      iconBgColor: "primary-div",
    },
  ];

  return (
    <>
      <Card
        className="border-0 rounded-3 p-4"
        style={{
          // background: "linear-gradient(104deg, #b27c26 2.4%, #d08f2c 112.33%)",
          background: "url('/images/banner_mth.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center center",
          height: "200px",
        }}
      >
        <div className="d-flex justify-content-between flex-wrap gap-3">
          <div className="mt-sm-4 ms-sm-4">
            <span
              className="fs-22 fw-medium d-block mb-2 text-white"
            >
              Hola {name || 'Usuario'} ✋
            </span>
            <h3 className="fs-28 text-white fw-900 mb-0">
              <span className="fw-normal text-white">Bienvenido a tu tienda </span>
              {country ? `en ${country}` : ''}
            </h3>
          </div>
          {/* <div className="py-sm-1">
            <img
              src="/images/store.png"
              alt="store"
              width={208}
              height={144}
            />
          </div> */}
        </div>
      </Card>

      {!isBlocked && (
        <div className="px-sm-4 px-xxl-5" style={{ marginTop: "-48px" }}>
          <Row className="justify-content-center">
            {storeStats.map((stat) => (
              <Col key={stat.id} md={4} sm={6}>
                <Card className="border-0 rounded-3 bg-white p-4 mb-4">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <span className="d-block mb-2">{stat.title}</span>
                      <h2 className={`text-${stat.changeColor} mb-2 fs-28`}>{stat.value}</h2>
                      <span
                        className={`d-inline-block bg-opacity-10 border px-2 rounded-pill fs-12 fw-medium`}
                      >
                        {stat.change}
                      </span>
                    </div>

                    <div className="flex-shrink-0">
                      <div
                        className={`bg-${stat.iconBgColor} bg-opacity-25 text-${stat.iconBgColor} text-center rounded-circle`}
                        style={{
                          width: "48px",
                          height: "48px",
                          lineHeight: "48px",
                        }}
                      >
                        <i className={`${stat.icon} fs-24`}></i>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      )}
    </>
  );
};

export default Welcome;
